import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import {
  SNACKBAR_HIDE,
  SNACKBAR_SHOW,
} from 'constants/index';

const initialState = {
  snackbar: {
    open: false,
    severity: 'success',
    message: null,
  },
};

const hide = (state) => update(state, {
  snackbar: { $set: initialState.snackbar },
});

const show = (state, action) => update(state, {
  snackbar: {
    $merge: {
      ...action.payload,
      open: true,
    },
  },
});

export default handleActions({
  [SNACKBAR_HIDE]: hide,
  [SNACKBAR_SHOW]: show,
}, initialState);
